import { combineReducers } from 'redux';
import { offersSection } from './offers/offers';
import { recipientSection } from './recipient/recipient';
import { senderSection } from './sender/sender';

export const sections = combineReducers({
  offers: offersSection,
  recipient: recipientSection,
  sender: senderSection,
});
